import { postJson } from '#/utils/http/postJson';

import type { ApiOrg } from './types/ApiOrg';

// TODO: Fix this the next time the file is edited.
// oxlint-disable-next-line typescript/no-explicit-any
export function apiValidateOrg(payload: Record<string, any>): Promise<{
  Org: ApiOrg;
}> {
  return postJson(`/data/website/organizations-validation`, payload);
}
